<template>
  <section class="characteristics">
    <h2>{{ $t('characteristicsTitle') }}</h2>
    <table>
      <tbody>
        <tr v-for="(value, key) in characteristics" :key="key">
          <td>
            {{ getTitle(key) }}
          </td>
          <td>
            <CharacteristicLink
              :text="getContent(key, value)"
              :href="productPath(key, value)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
// import { mapState } from 'vuex'
import categoryFiltersMixin from '@/components/category/categoryFiltersMixin'
import CharacteristicLink from '@/components/product/CharacteristicLink'
import { mapState } from 'vuex'

export default {
  name: 'Characteristics',
  components: {
    CharacteristicLink,
  },
  props: {
    product: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  mixins: [categoryFiltersMixin],
  methods: {
    getTitle(key) {
      if (!this.characteristicsMapping[key]) {
        let item

        for (let i = 0; i < this.filters.length; i++) {
          const { attributes } = this.filters[i]
          for (let j = 0; j < attributes.length; j++) {
            const element = attributes[j]
            if (element.slug === key) {
              item = element
              break
            }
          }

          if (item) {
            break
          }
        }

        if (item) {
          return item[`name_${this.$i18n.locale}`]
        } else {
          return key
        }
      }

      return this.characteristicsMapping[key][`name_${this.$i18n.locale}`]
    },
    productPath(key, value) {
      const { used } = this.product
      const { currentPath } = this.category
      const rootPath = `/product-category${used ? '/used' : ''}`
      const mainPath = `${rootPath}/${currentPath}`
      let path = `${mainPath}?${key}=${value}`

      if (this.SEOCategoriesUrls.includes(path)) {
        return path
      } else if (key === 'new-or-used') {
        return `${rootPath}/${currentPath}`
      } else if (key === 'model') {
        return `/product-category/${currentPath}`
      }

      return undefined
    },
    getContent(key, value) {
      if (
        !this.characteristicsMapping[key] ||
        (this.characteristicsMapping[key] &&
          !this.characteristicsMapping[key]?.options[value])
      ) {
        return value
      }

      return this.characteristicsMapping[key].options[value][
        `name_${this.$i18n.locale}`
      ]
    },
  },
  computed: {
    ...mapState(['SEOCategoriesMeta']),
    SEOCategoriesUrls() {
      return this.SEOCategoriesMeta.map(({ url }) => url)
    },
    characteristicsMapping() {
      const categoryFiltersMapping = Object.fromEntries(
        this.categoryFilters.map(({ slug, name_ru, name_ua, options }) => [
          slug,
          {
            name_ru,
            name_ua,
            options: Object.fromEntries(
              options.map(({ slug, name_ru, name_ua }) => [
                slug,
                { name_ru, name_ua },
              ])
            ),
          },
        ])
      )
      return categoryFiltersMapping
      // const productFilters = this.product.filters[0]
      // return Object.entries(productFilters).map(([key, value]) => {
      //   return
      // })
    },
    characteristics() {
      return this.product.filters[0]
    },
  },
}
</script>

<style></style>
